import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Button } from '@material-ui/core';
import moment from 'moment';
import { Edit as EditIcon } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  container: {
    borderBottom: `1px solid ${theme.palette.lightGrey.default}`,
    padding: '10px 16px 10px 0',
    display: 'flex',
    justifyContent: 'space-between'
  },
  danger: {
    color: 'red'
  },
  warning: {
    color: 'orange'
  },
  heading: {
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    marginBottom: 3
  },
  subHeading: {
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    marginBottom: 3
  },
  textContent: {},
  buttonContent: {}
}));

const calculateExpiryPrefiex = (source, isExpired) => {
  if (source === 'training') {
    if (isExpired) {
      return 'd';
    } else {
      return 's';
    }
  } else {
    return '';
  }
};

const RecordsListForTraining = (props) => {
  const classes = useStyles();
  const {
    allCourses,
    items,
    handleAddEditClick,
    dateLabel,
    titleField,
    subTitleField,
    dateField,
    courseId,
    source,
    seeMore, 
    branchId
  } = props;

  React.useEffect(
    () => {
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [seeMore]
  );

  return (
    <React.Fragment>
      {items &&
        items.map((item, index) => {
          const isExpired = moment().isAfter(item[dateField]);
          const expiryPrefix = calculateExpiryPrefiex(source, isExpired);

          //Because only 5 items are to be shown.
          if (seeMore && index > 4) {
              return null;
          }

          return (
            <div className={classes.container} key={index}>
              <div className={classes.textContent}>
                <Typography variant="h6" className={classes.heading}>
                  {item[titleField]}
                </Typography>
                <Typography variant="subtitle1" className={classes.subHeading}>
                  {item[subTitleField]}
                </Typography>
                <div
                  className={`
                  ${isExpired ? classes.danger : ''} 
                  ${item.upcomingExpiryDate === true ? classes.warning : ''}`}
                >
                  {item[dateField] !== null
                    ? `${dateLabel}${expiryPrefix}`
                    : ''}{' '}
                  {item[dateField] !== null
                    ? moment(item[dateField]).format('DD/MM/YYYY')
                    : ''}
                </div>
              </div>
              <div className={classes.buttonContent}>
                <Button
                  color="secondary"
                  startIcon={<EditIcon />}
                  className={classes.editButton}
                  onClick={() => {
                    let course =
                      allCourses &&
                      allCourses.find((o) => o.id === item[courseId]);
                    handleAddEditClick({ ...course });
                  }}
                >
                  Add/Edit
                </Button>
              </div>
            </div>
          );
        })}
    </React.Fragment>
  );
};

export default RecordsListForTraining;
